import { render, staticRenderFns } from "./ShipmentStatusButton.vue?vue&type=template&id=2b185546&scoped=true&"
import script from "./ShipmentStatusButton.vue?vue&type=script&lang=js&"
export * from "./ShipmentStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentStatusButton.vue?vue&type=style&index=0&id=2b185546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b185546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b185546')) {
      api.createRecord('2b185546', component.options)
    } else {
      api.reload('2b185546', component.options)
    }
    module.hot.accept("./ShipmentStatusButton.vue?vue&type=template&id=2b185546&scoped=true&", function () {
      api.rerender('2b185546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/buttons/ShipmentStatusButton.vue"
export default component.exports